module.exports = __webpack_public_path__ + "img/delegate.0207094e.png";